<template>
  <div class="rContainer">
    <dl class="bsTitleBox">
      <dt class="bsTitle">
        发送消息
      </dt>
    </dl>
    <div class="bsBox1">
      <dl>
        <dt>消息标题</dt>
        <dd>
          <a-input
            maxlength="20"
            placeholder="请输入消息标题，最多20个字"
            :value="msgList.messageTitle"
            @blur="e => formateContent('messageTitle', e.target.value)"
            @change="e => contentChange('messageTitle', e.target.value)"
          />
        </dd>
      </dl>
      <dl>
        <dt>消息类型</dt>
        <dd>
          <a-select
            v-model="selectValue"
            placeholder="请选择消息类型"
            style="width: 240px;"
            @change="chooseType"
          >
            <a-select-option value="0">
              目标制定开启通知
            </a-select-option>
            <a-select-option value="1">
              目标制定关闭通知
            </a-select-option>
            <a-select-option value="2">
              自评开启通知
            </a-select-option>
            <a-select-option value="3">
              自评关闭通知
            </a-select-option>
            <a-select-option value="4">
              上级评开启通知
            </a-select-option>
            <a-select-option value="5">
              上级评关闭通知
            </a-select-option>
            <a-select-option value="6">
              BU合议通知
            </a-select-option>
            <a-select-option value="7">
              季度绩效结果一键推送
            </a-select-option>
            <a-select-option value="10">
              年度绩效结果一键推送
            </a-select-option>
            <a-select-option value="8">
              面谈纪要编辑开启通知
            </a-select-option>
            <a-select-option value="9">
              面谈纪要编辑关闭通知
            </a-select-option>
          </a-select>
        </dd>
      </dl>
      <dl v-if="showYearSelect">
        <dt>选择年度</dt>
        <dd>
          <a-select
            v-model="selectYear"
            placeholder="请选择年度"
            style="width:120px;"
            @change="chooseYear"
          >
            <a-select-option
              v-for="(y,index) in years"
              :key="index"
              :value="y"
            >
              {{ y }}
            </a-select-option>
          </a-select>
        </dd>
      </dl>
      <dl>
        <dt>消息内容</dt>
        <dd>
          <div class="contentBox">
            <a-textarea
              style="min-height: 90px;"
              placeholder="请输入短信内容，最多200个字；支持中英文输入"
              maxlength="200"
              :autosize="{ minRows: 2 }"
              :value="msgList.messageContent"
              @blur="e => formateContent('messageContent', e.target.value)"
              @change="e => contentChange('messageContent', e.target.value)"
            />
            <span class="countTips"> {{ contentCount }}/200 </span>
          </div>
        </dd>
      </dl>
      <dl>
        <dt class="nopad">
          发送时间
        </dt>
        <dd>
          <a-radio-group
            default-value="sendNow"
            :value="SendType"
            @change="changeSendingType"
          >
            <a-radio value="sendNow">
              立即发送
            </a-radio>
            <a-radio
              v-if="!showYearSelect"
              value="sendtiming"
            >
              定时发送
            </a-radio>
          </a-radio-group>
          <div class="timeBox">
            <div
              v-if="isSendtiming"
            >
              <a-date-picker
                show-time
                style="width: 240px;"
                placeholder="开始日期和时间"
                @change="chooseDate"
              />
            </div>
          </div>
        </dd>
      </dl>
      <div class="bs-btns">
        <a-button
          type="primary"
          :disabled="disabledBtn"
          @click="handleComfirm"
        >
          提交
        </a-button>
        <a-button
          @click="handleReset"
        >
          重置
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Select, Radio, DatePicker, Button, Modal, message } from 'ant-design-vue'

Vue.use(Input)
Vue.use(Select)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(Modal)

export default {
  name: 'Message',
  data() {
    return {
      selectValue: undefined,
      contentCount: 0,
      isSendtiming: false,
      disabledBtn: true,
      msgList: {},
      SendType: 'sendNow',
      noError: false,
      showYearSelect: false,
      selectYear: undefined,
      year: 0,
      years: [],
    }
  },
  watch: {
    noError(v) {
      if (v) {
        this.disabledBtn = false
      } else {
        this.disabledBtn = true
      }
    },
  },
  created() {
    this.msgList.isSchedule = false
  },
  methods: {
    // 格式化标题
    formateContent(k, v) {
      // 去掉全部多余空格
      v = v.replace(/[ ]+/g, ' ')
      if (k === 'messageContent') {
        this.contentCount = v.length
      }
      this.$set(this.msgList, k, v)
    },
    // 收集标题/内容的数据
    contentChange(k, v) {
      if (k === 'messageContent') {
        this.contentCount = v.length
      }
      this.$set(this.msgList, k, v)
      this.judgeSubmission()
    },
    // 选择发送类型
    chooseType(value) {
      if (value) {
        // string类型转化为数字类型
        value = Number(value)
        switch (value) {
          case 0:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩目标制定入口已开启，请尽快完成Qx业绩目标制定并上传系统~')
            break
          case 1:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩目标制定入口将于xx年xx月xx日xx：xx关闭，请务必在入口关闭前完成Qx业绩目标制定并上传系统~')
            break
          case 2:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩自评入口已开启，请务必在xx年xx月xx日xx：xx前完成Qx业绩自评~')
            break
          case 3:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩自评入口将于xx年xx月xx日xx：xx关闭，请务必在入口关闭前完成Qx业绩自评~')
            break
          case 4:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩上级评入口已开启，请务必在xx年xx月xx日xx：xx前完成直属下级Qx的业绩上级评~')
            break
          case 5:
            this.$set(this.msgList, 'messageContent', 'xx年Qx业绩上级评入口将于xx年xx月xx日xx：xx关闭，请务必在入口关闭前完成直属下级Qx的业绩上级评~')
            break
          case 6:
            this.$set(this.msgList, 'messageContent', 'xx年Qx合议结果上传入口已开启，请务必在xx年xx月xx日xx：xx前完成BU合议并上传系统~')
            break
          case 7:
            this.$set(this.msgList, 'messageContent', 'xx年Qx的绩效结果为')
            break
          case 8:
            this.$set(this.msgList, 'messageContent', 'xx年Qx面谈纪要编辑入口已开启，请务必在xx年xx月xx日xx：xx前完成直属下级Qx的绩效面谈并在线提交面谈纪要')
            break
          case 9:
            this.$set(this.msgList, 'messageContent', 'xx年Qx面谈纪要编辑入口将于xx年xx月xx日xx：xx关闭，请务必在入口关闭前完成直属下级Qx的绩效面谈并在线提交面谈纪要')
            break
          case 10:
            this.$set(this.msgList, 'messageContent', 'xx年的年度绩效结果为')
            break
        }
        if (value === 10) {
          this.$set(this, 'showYearSelect', true)
          this.setYearData()
        }
        // eslint-disable-next-line
      console.log('select value', this.selectValue)
        this.$set(this.msgList, 'messageTypeEnum', value)
        this.judgeSubmission()
      }
    },
    // 设置年度绩效发送的年度渲染数据
    setYearData() {
      // 设置年度开关的当前年和选项逻辑：当前月份小于6月，当前年展示为上一年；年度选项从2020年起直到当前年份；
      const myDate = new Date()
      const year = myDate.getFullYear()
      const month = myDate.getMonth() + 1
      if (month < 6) {
        this.year = year - 1
      } else {
        this.year = year
      }
      for (let y = 2020; y <= year; y++) {
        this.years.push(`${y}`)
      }
    },
    chooseYear(e) {
      // eslint-disable-next-line
      console.log(e, typeof(e), this.selectYear)
      this.$set(this.msgList, 'year', e)
    },
    // 切换发送时间模式
    changeSendingType(e) {
      // eslint-disable-next-line
      console.log('data1', this.msgList)
      this.SendType = e.target.value
      if (this.SendType === 'sendtiming') {
        this.isSendtiming = true
        this.msgList.isSchedule = true
      } else {
        this.isSendtiming = false
        this.msgList.isSchedule = false
        // 移除对象数组中该项内容
        delete this.msgList.scheduleTime
      }
      this.judgeSubmission()
    },
    // 选择定时发送日期时间触发器，收集数据
    chooseDate(value, dateString) {
      // eslint-disable-next-line
      console.log('选择时间', dateString)
      this.$set(this.msgList, 'isSchedule', true)
      this.$set(this.msgList, 'scheduleTime', dateString)
      this.judgeSubmission()
    },
    // 重置按钮，清空内容
    handleReset() {
      this.msgList = {
        isSchedule: false,
      }
      this.selectValue = undefined
      this.contentCount = 0
      if (this.SendType === 'sendtiming') {
        this.isSendtiming = false
        this.SendType = 'sendNow'
      }
      this.noError = false
      this.selectYear = undefined
      this.showYearSelect = false
      // eslint-disable-next-line
    //   console.log('msgList', this.msgList)
    //   console.log('msgList.messageTypeEnum', this.msgList.messageTypeEnum)
    },
    // 判断是否满足提交条件
    judgeSubmission() {
      const item = this.msgList
      if (item.messageTitle && item.messageTypeEnum !== undefined && item.messageContent) {
        if (item.isSchedule) {
          if (item.scheduleTime) {
            this.noError = true
          } else {
            this.noError = false
          }
        } else {
          this.noError = true
        }
      }
    },
    // 满足提交条件，弹出二次确认框
    handleComfirm() {
      // eslint-disable-next-line
      console.log('msgList', this.msgList)
      Modal.confirm({
        title: '确定要提交吗？',
        content: '确定提交后无法撤回哦~',
        icon: 'exclamation-circle',
        okText: '提交',
        cancelText: '不提交',
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    // 提交表单到后端
    async handleSubmit() {
      try {
        await this.$api.backstage.createTask(this.msgList)
        message.success('提交成功')
        this.handleReset()
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
  },
}
</script>
<style lang="less">
@import '~@assets/style/variables.less';
.bsBox1{padding: 40px 0 40px 80px;
dl{display: flex; flex-direction: row; margin-bottom: 20px;}
dt{width:72px; padding-top: 6px; font-size: 14px; font-weight: 500;}
dt.nopad{padding-top: 0;}
dd{width:400px; margin-bottom: 0;}
}
.contentBox{position: relative;}
.countTips{position: absolute; font-size: 12px; color: #bbb; right: 10px; bottom: 4px;}
.timeBox { padding-top: 16px; height: 80px;}
.bs-btns{padding-left: 72px; font-size: 0;
button + button{margin-left: 24px;}}
</style>
